import { BackgroundImage } from './BackgroundImage';

export type { TypeBackgroundImageProps } from './types';
export default BackgroundImage;
